import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountPageHeader from '../../../components/AccountPageHeader';
import PageIntro from '../../../components/PageIntro';
import '../../../styles/account-pages.css';

const SORT_OPTIONS = [
  { value: 'data', label: 'Data', description: 'Organize pelo dia da movimentação' },
  { value: 'valor', label: 'Valor', description: 'Organize pelo valor monetário' },
  { value: 'nome', label: 'Nome', description: 'Organize em ordem alfabética' },
];

const DIRECTION_OPTIONS = [
  { value: 'asc', label: 'Crescente', description: 'Do menor ou mais antigo para o maior' },
  { value: 'desc', label: 'Decrescente', description: 'Do maior ou mais recente para o menor' },
];

const SortSettings = () => {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({ key: 'data', direction: 'asc' });

  useEffect(() => {
    try {
      const storedSortConfig = JSON.parse(localStorage.getItem('sortConfig'));
      if (storedSortConfig?.key && storedSortConfig?.direction) setSortConfig(storedSortConfig);
    } catch (error) {
      // Preferência antiga inválida: mantém a configuração padrão.
    }
  }, []);

  const updateSortConfig = (nextConfig) => {
    setSortConfig(nextConfig);
    localStorage.setItem('sortConfig', JSON.stringify(nextConfig));
  };

  const renderOptions = (name, options, selected, onChange) => (
    <div className="setting-choice-list" role="radiogroup">
      {options.map((option) => (
        <label className={`setting-choice ${selected === option.value ? 'setting-choice--selected' : ''}`} key={option.value}>
          <input type="radio" name={name} value={option.value} checked={selected === option.value} onChange={() => onChange(option.value)} />
          <span>
            <strong>{option.label}</strong>
            <small>{option.description}</small>
          </span>
        </label>
      ))}
    </div>
  );

  return (
    <div className="account-page">
      <AccountPageHeader title="Ordenação" onBack={() => navigate(-1)} />
      <main className="account-content">
        <PageIntro description="Defina como suas movimentações são organizadas no aplicativo." />
        <section className="account-section" aria-labelledby="sorting-title">
          <div className="account-section__heading">
            <h2 id="sorting-title">Ordem das movimentações</h2>

          </div>
          <div className="setting-choice-group">
            <h3>Critério</h3>
            <p>Escolha a informação usada para ordenar.</p>
            {renderOptions('sort-key', SORT_OPTIONS, sortConfig.key, (key) => updateSortConfig({ ...sortConfig, key }))}
          </div>
          <div className="setting-choice-group">
            <h3>Direção</h3>
            <p>Defina em qual sentido a lista deve aparecer.</p>
            {renderOptions('sort-direction', DIRECTION_OPTIONS, sortConfig.direction, (direction) => updateSortConfig({ ...sortConfig, direction }))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default SortSettings;